"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CargoManLtd = void 0;
exports.CargoManLtd = {
    id: 'cargoManLtd',
    companyName: 'Cargo Man Ltd',
    transportModes: ['air'],
    freightGate: {
        isOnboarded: true,
        realm: 'cargoManLtd',
    },
    isInternal: false,
    isActive: true,
    countries: ['IL'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FyZ29NYW5MdGQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvQ2FyZ29NYW5MdGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxXQUFXLEdBQVU7SUFDOUIsRUFBRSxFQUFFLGFBQWE7SUFDakIsV0FBVyxFQUFFLGVBQWU7SUFDNUIsY0FBYyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3ZCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxhQUFhO0tBQ3ZCO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9